import { useState, useEffect } from "react";

export const useDatadogAwsConsolelogin = () => {
  const [embedUrl, setEmbedUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchEmbedUrl = async () => {
    try {
      setLoading(true);
      setError(null);
      
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      const url = import.meta.env.VITE_DATADOG_AWS_CONSOLE_EMBED_URL;
      if (!url) {
        throw new Error("Datadog URL not configured");
      }
      
      setEmbedUrl(url);
    } catch (err) {
      setError(err.message || "Error loading Datadog dashboard");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEmbedUrl();
  }, []);

  return {
    embedUrl,
    loading,
    error,
    refetch: fetchEmbedUrl
  };
};